<template>
  <v-card class="my-0">
    <v-card-text class="pb-0">
      <v-row align="center">
        <v-col cols="12" class="py-0">
          <div class="body-2 grey--text text--darken-1">{{ $t('views.orders.filterBy') }}</div>
        </v-col>
        <v-col cols="12" sm="4" lg="3">
          <v-select :value="value.service || ''"
            @change="onServiceChanged"
            :items="serviceOptions"
            :label="serviceLabel || $t('views.orders.paymentService')"
            item-text="label" item-value="value"
            dense outlined hide-details>
          </v-select>
        </v-col>
        <v-col cols="12" sm="4" lg="3" v-if="hasPayType">
          <v-select :value="value.payType || ''"
            @change="payType => emitChange({ payType })"
            :items="paymentTypeOptions"
            :label="$t('views.orders.paymentType')"
            item-text="label" item-value="value"
            dense outlined hide-details>
          </v-select>
        </v-col>
        <v-col cols="12" sm="4" lg="3" v-if="modeOptions && modeOptions.length">
          <v-select :value="value.mode || ''"
            @change="onModeChanged"
            :items="modeOptions"
            :label="$t('views.orders.paymentMode')"
            item-text="label" item-value="value"
            dense outlined hide-details>
          </v-select>
        </v-col>
        <v-col cols="12" sm="4" lg="3">
          <v-select :value="value.status || ''"
            @change="status => emitChange({ status })"
            :items="statusOptions"
            :label="$t('views.orders.status')"
            item-text="label" item-value="value"
            dense outlined hide-details>
          </v-select>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  /**
   * 兩個訂單列表頁共用的篩選列，各頁傳入自己的選項清單。
   * 支付方式是否出現只看選項的 hasPayType 旗標，本元件不需知道哪些服務是信用卡。
   * 結帳模式只有 DDPay 頁會傳 modeOptions。ttp／ba 的 payment_service 恆為 NULL，
   * 與支付服務同時選會保證撈到 0 筆，故兩者互斥。
   */
  // 這兩種結帳模式的訂單不會進 DDPG，payment_service 恆為 NULL。
  const SERVICE_LESS_MODES = [ 'ttp', 'ba' ];

  export default {
    name: 'OrderFilters',

    props: {
      // { service, payType, status, mode }
      value: {
        type: Object,
        required: true
      },
      serviceOptions: {
        type: Array,
        required: true
      },
      statusOptions: {
        type: Array,
        required: true
      },
      paymentTypeOptions: {
        type: Array,
        required: true
      },
      // 有傳才渲染結帳模式下拉。
      modeOptions: {
        type: Array,
        default: null
      },
      // DDPay 頁用來標明支付服務只涵蓋已進金流的訂單。
      serviceLabel: {
        type: String,
        default: ''
      }
    },

    computed: {
      selectedService() {
        return this.serviceOptions.find(o => o.value === this.value.service);
      },

      hasPayType() {
        return Boolean(this.selectedService && this.selectedService.hasPayType);
      }
    },

    watch: {
      // 選項清單換掉（例如切語言、改頁面）而選取值已不在清單內時，把它清掉。
      // 讓不同步在畫面上看得見，而不是靜默送出未篩選的請求。
      serviceOptions() {
        if (this.value.service && !this.selectedService)
          this.emitChange({ service: '', payType: '' });
      }
    },

    methods: {
      emitChange(patch) {
        this.$emit('input', { ...this.value, ...patch });
      },

      onServiceChanged(service) {
        // 支付方式只對信用卡類有意義，切到其它服務時清掉，避免殘留無效組合。
        let selected = this.serviceOptions.find(o => o.value === service);
        let payType = (selected && selected.hasPayType)? this.value.payType: '';
        // 這些模式沒有 payment_service，與支付服務同時選必定 0 筆。
        let mode = (service && SERVICE_LESS_MODES.indexOf(this.value.mode) >= 0)? '': this.value.mode;
        this.emitChange({ service, payType, mode });
      },

      onModeChanged(mode) {
        let service = SERVICE_LESS_MODES.indexOf(mode) >= 0? '': this.value.service;
        this.emitChange({ mode, service, payType: service? this.value.payType: '' });
      }
    }
  };
</script>
